// Chat socket event constants (frontend only)

const ROOM_PREFIXES = {
  CONVERSATION: 'conversation-',
  EVENT: 'event-',
};

const SOCKET_EVENTS = {
  // Client -> Server
  CONVERSATION_SUBSCRIBE: 'conversation:subscribe',
  EVENT_SUBSCRIBE: 'event:subscribe',
  CONVERSATION_JOIN: 'conversation:join',
  CONVERSATION_LEAVE: 'conversation:leave',
  EVENT_JOIN: 'event:join',
  EVENT_LEAVE: 'event:leave',
  MESSAGE_SEND: 'message:send',
  GROUP_MESSAGE_SEND: 'group_message:send',
  START_TYPING: 'startTyping',
  STOP_TYPING: 'stopTyping',
  START_EVENT_TYPING: 'startEventTyping',
  STOP_EVENT_TYPING: 'stopEventTyping',
  HEARTBEAT: 'heartbeat',
  LOGOUT: 'logout',

  // Server -> Client
  MESSAGE_NEW: 'message:new',
  GROUP_MESSAGE_NEW: 'group_message:new',
  NOTIFICATION_NEW: 'notification:new',
  TYPING_UPDATE: 'typingUpdate',
  EVENT_TYPING_UPDATE: 'eventTypingUpdate',
  GROUP_TYPING_UPDATE: 'groupTypingUpdate',
  PRESENCE_UPDATE: 'presenceUpdate',
  EVENT_PRESENCE_UPDATE: 'eventPresenceUpdate',
  GROUP_PRESENCE_UPDATE: 'groupPresenceUpdate',
  EVENT_PARTICIPANT_UPDATE: 'eventParticipantUpdate',
  GROUP_PARTICIPANT_UPDATE: 'groupParticipantUpdate',
  AUTHENTICATED: 'authenticated',
  AUTH_ERROR: 'authError',
  PERMISSION_DENIED: 'permissionDenied',

  // Socket.IO built-in events
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  ERROR: 'error',
  CONNECT_ERROR: 'connect_error',
  RECONNECT: 'reconnect',
  RECONNECTING: 'reconnecting',
  RECONNECT_ERROR: 'reconnect_error',
  RECONNECT_FAILED: 'reconnect_failed',
};

export {
  ROOM_PREFIXES,
  SOCKET_EVENTS,
};
